import React from 'react';

import { motion } from 'framer-motion';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import { fonts } from '../gatsby-theme-material-ui-top-layout/theme';

import styled from 'styled-components';

import EthereumSpacetimeGraphic2 from '../img/ethereum-spacetime-graphic-2.svg';

import {
  PROPY_SPACE_GREY_DARK,
  PROPY_BLACK,
} from '../utils';

const ZoneContainer = styled.div`
  width: 100%;
  overflow: visible;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Zone = styled.div`
  max-width: 1080px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: ${props => props.mobile ? 'column-reverse' : 'row'};
`

const TypographyContainer = styled.div`
  max-width: ${props => props.mobile ? '300px' : '500px'};
  margin-left: ${props => props.mobile ? 'auto' : '0px'};
  margin-right: ${props => props.mobile ? 'auto' : '0px'};
  margin-bottom: ${props => props.mobile ? props.theme.spacing(4) : '0px'};
  text-align: ${props => props.mobile ? 'center' : 'left'};
`

const TypographySpacer = styled.div`
  margin-top: ${props => props.theme.spacing(1.5)};
`

const OverflowGraphicContainer = styled.div`
  max-width: ${props => props.mobile ? 'auto' : '500px'};
`

const MeshGraphic = styled(Box).withConfig({
  shouldComponentUpdate: true,
})`
  right: ${props => props.mobile ? 'auto' : '50%'};
  position: relative;
  width: ${props => props.mobile ? '500px' : 'auto'};
  max-width: ${props => props.mobile ? '100%' : '700px'};
  height: 100%;

  // We use these classes to select the Ethereum logos from the contents of the EthereumSpacetimeGraphic2 svg
  .uuid-46e10be5-1dc5-41f8-a618-7ca0733cfd8b,
  .uuid-912c34bc-6e16-4ced-82e7-e0d717b46cbd,
  .uuid-e913f830-3952-4bb6-ba7a-6f3eff728b2c {
    transform-origin: center;
    transform-box: fill-box;
    opacity: 0;
  }
`

const CoinbasePartnership = ({ isConsideredMobile }) => {
  return (
    <ZoneContainer>
      <Zone mobile={isConsideredMobile}>
        <OverflowGraphicContainer mobile={isConsideredMobile}>
          <motion.div
            style={{ width: '100%', height: '100%' }}
          >
            <MeshGraphic
              mobile={isConsideredMobile}
              component={EthereumSpacetimeGraphic2}
              sx={{
                '& .uuid-46e10be5-1dc5-41f8-a618-7ca0733cfd8b': {
                  animation: 'floatAndFade 4s infinite ease-in-out, fadeIn 1s ease-out forwards',
                  animationDelay: '0s, 0s',
                },
                '& .uuid-912c34bc-6e16-4ced-82e7-e0d717b46cbd': {
                  animation: 'floatAndFade 4s infinite ease-in-out, fadeIn 1s ease-out forwards',
                  animationDelay: '1.3s, 0.3s',
                },
                '& .uuid-e913f830-3952-4bb6-ba7a-6f3eff728b2c': {
                  animation: 'floatAndFade 4s infinite ease-in-out, fadeIn 1s ease-out forwards',
                  animationDelay: '2.6s, 0.6s',
                },
                '@keyframes floatAndFade': {
                  '0%, 100%': {
                    transform: 'translateY(0)',
                  },
                  '50%': {
                    transform: 'translateY(-20px)',
                  },
                },
                '@keyframes fadeIn': {
                  '0%': {
                    opacity: 0,
                  },
                  '100%': {
                    opacity: 1,
                  },
                },
              }}
            />
          </motion.div>
        </OverflowGraphicContainer>
        <TypographyContainer mobile={isConsideredMobile}>
          <TypographySpacer>
            <Typography 
              variant="h4"
              sx={{ fontFamily: fonts.spaceGrotesk, color: PROPY_BLACK, letterSpacing: '-0.01em', textAlign: isConsideredMobile ? 'center' : 'left', ...(isConsideredMobile && { fontSize: '24px', lineHeight: '24px' }) }}
            >
              Deeds onchain
            </Typography>
          </TypographySpacer>
          <TypographySpacer>
            <Typography sx={{ fontFamily: fonts.robotoMono, color: PROPY_SPACE_GREY_DARK, letterSpacing: '-0.01em', fontWeight: 300, textAlign: isConsideredMobile ? 'center' : 'left', ...(isConsideredMobile && { fontSize: '14px', lineHeight: '14px' }) }}>
              Add an extra layer of security by recording your deed onchain.
            </Typography>
          </TypographySpacer>
        </TypographyContainer>
      </Zone>
    </ZoneContainer>
  );
};

export default CoinbasePartnership;